import axios from "axios";
import Config from "../../config";

const ReportAdsDetail = params => {
    const {channel_id, keyword = '', start_date, end_date} = params
    return axios({
        method: "POST",
        url: (Config.url || '') + "/api/report/ads-detail",
        data: { keyword, channel_id, start_date, end_date }
    });
};

export default ReportAdsDetail;
